import { PopupProps } from 'react-popup-manager';
import { ConfirmationModalComponent } from 'commons/components';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { useTranslation } from 'core/i18n/i18n';
import {
    OPERATOR_CUSTOM_NOTIFICATION_FORM_EDIT_CONFIRMATION_KEYS,
    OPERATOR_CUSTOM_NOTIFICATION_FORM_SUBMIT_KEYS,
} from 'modules/settings/pods/settings-operator-custom-notifications/settings-operator-custom-notification-form/settings-operator-custom-notification-form.constants';

export interface CounterResetConfirmationModalComponentProps extends PopupProps {
    onConfirm: () => Promise<unknown>;
}

export const CounterResetConfirmationModalComponent: React.FC<CounterResetConfirmationModalComponentProps> = ({
    onConfirm,
    isOpen,
    onClose,
}) => {
    const { t } = useTranslation();

    return (
        <ConfirmationModalComponent
            isOpen={isOpen}
            onClose={onClose}
            title={t(OPERATOR_CUSTOM_NOTIFICATION_FORM_EDIT_CONFIRMATION_KEYS.title)}
            buttonText={t(OPERATOR_CUSTOM_NOTIFICATION_FORM_SUBMIT_KEYS.edit)}
            actionOnClick={onConfirm}
        >
            <PocTypography variant="body1">
                {t(OPERATOR_CUSTOM_NOTIFICATION_FORM_EDIT_CONFIRMATION_KEYS.question)}
            </PocTypography>
            <PocTypography variant="body1">
                {t(OPERATOR_CUSTOM_NOTIFICATION_FORM_EDIT_CONFIRMATION_KEYS.consequence)}
            </PocTypography>
        </ConfirmationModalComponent>
    );
};
